const routes = {
  organization: '/organizations/',
  organizationSpreadsheetUpload: '/organizations/import-excel/',
  organizationImportBatches: '/organizations/import-excel-batches/',
  organizationImportBatch: (batchId) => `/organizations/import-excel-batches/${batchId}/`,
  saveToDraft: '/organizations/save-to-draft/',
  getDraft: '/organizations/draft/',
  comments: '/project_comments/',
  geocoverage: '/geocoverages/',
  news: '/news/',
  program_areas: '/program_areas/',
  projects: '/projects/',
  auth: {
    reset_password: '/password/reset/',
    validate_token: '/password/validate_token/',
    verify_token: '/password/confirm/',
  },
};

export default routes;
